import React, { useState } from "react";
import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Navigation } from "lucide-react";

export default function RouteButton({ lat, lng, label, size = "default", className = "" }) {
  const [open, setOpen] = useState(false);
  if (lat == null || lng == null) return null;
  const q = encodeURIComponent(label || `${lat},${lng}`);

  const links = [
    { name: "Google Maps", url: `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&destination_place_id=${q}` },
    { name: "Waze", url: `https://waze.com/ul?ll=${lat},${lng}&navigate=yes` },
    { name: "Apple Maps", url: `https://maps.apple.com/?daddr=${lat},${lng}&q=${q}` },
    { name: "OpenStreetMap", url: `https://www.openstreetmap.org/directions?to=${lat},${lng}` },
  ];

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button size={size} className={`bg-blue-900 hover:bg-blue-950 text-white rounded-xl ${className}`} data-testid="route-button">
          <Navigation size={14} className="mr-1.5"/> Como chegar
        </Button>
      </PopoverTrigger>
      <PopoverContent side="bottom" align="end" sideOffset={6} className="w-56 p-2 rounded-xl z-[1000] shadow-2xl">
        <p className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold px-2 py-1">Escolha o app</p>
        {links.map((l) => (
          <a
            key={l.name}
            href={l.url}
            target="_blank"
            rel="noreferrer"
            onClick={() => setOpen(false)}
            className="block px-3 py-2 rounded-lg text-sm text-stone-800 hover:bg-stone-100 transition-colors"
            data-testid={`route-${l.name.replace(/\s/g, "-").toLowerCase()}`}
          >
            {l.name}
          </a>
        ))}
      </PopoverContent>
    </Popover>
  );
}
